module.exports = __webpack_public_path__ + "img/1459-1.32cb3c17.jpg";